import { Building } from './building.model';
import { RoomBooking } from './room-booking.model';

export class Room {
  available?: boolean;
  building?: Building;
  buildingId?: string;
  capacity?: number;
  defaultFullDayPrice: number;
  defaultHalfDayPrice: number;
  disabledAccessAvailable: boolean;
  etags?: string;
  featureInstances?: any[];
  floorName?: string;
  generatedResourceName?: string;
  id?: string;
  isEnabled: boolean;
  kind?: string;
  link?: string;
  myGoogleData?: any;
  pictures?: string[]; // URI format
  resourceCategory?: string;
  resourceEmail?: string;
  resourceId?: string;
  resourceName?: string;
  resourceType?: string;
  roomBookings?: RoomBooking[];

  constructor(json: any = {}) {
    if (json !== null) {
      Object.assign(this, json);

      if (json.myGoogleData) {
        Object.assign(this, json.myGoogleData);
      }
    }
  }
}
